var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 108,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C3CAD9",
    fillRule: "evenodd",
    d: "M54 101.25c26.096 0 47.25-21.154 47.25-47.25 0-26.095-21.154-47.25-47.25-47.25C27.905 6.75 6.75 27.905 6.75 54c0 26.096 21.155 47.25 47.25 47.25m0 6.75c29.823 0 54-24.177 54-54S83.823 0 54 0 0 24.177 0 54s24.177 54 54 54",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C3CAD9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M58.046 29.867V58.2l-20.45 16.189"
  })));
};
export default SvgPending;